import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { chartMapping } from '../../../shared/data/chartSeriesChange';
import { Action } from '../../../types';

import { PerformanceAction, PerformanceActionType, PerformanceStore } from './PerformanceReducer.types';

// @ts-ignore
export const initialState: PerformanceStore = Immutable.fromJS({
  leaderboard: {},
  isFetching: false,
  activities: {
    count: 0,
    results: {},
  },
});

function getChartType(actions: Action<PerformanceAction>) {
  if (actions.payload.data.records.schema.name === 'base-payment') {
    return 'performance-stacked-columns';
  }

  return actions.payload.data.type === 'CUMULATIVE' ? 'performance-area' : 'performance-columns';
}

const PerformanceReducer = handleActions<any>(
  {
    PERFORMANCE_REQUEST: (state: PerformanceStore) => state.set('isFetching', true),

    PERFORMANCE_RESPONSE_FAILURE: (state: PerformanceStore) => state.set('isFetching', false),

    PERFORMANCE_RESPONSE: (state: PerformanceStore, actions: PerformanceActionType) =>
      state.set('isFetching', false).set('leaderboard', Immutable.fromJS(actions.payload.data.leaderboard)),

    AUTHENTICATION_LOGOUT: () => initialState,

    PERFORMANCE_ACTIVITIES_FAILURE: (state: PerformanceStore) => state.set('isFetching', false),
    PERFORMANCE_ACTIVITIES_REQUEST: (state: PerformanceStore) => state.set('isFetching', true),
    PERFORMANCE_ACTIVITIES_RESPONSE: (state: PerformanceStore, actions: PerformanceActionType) => {
      let results: Object = {};
      actions.payload.data.results.forEach((activity: any) => {
        results = {
          ...results,
          [activity.name]: {
            title: activity.title,
            isfetching: false,
            details: null,
          },
        };
      });

      return state
        .set('isFetching', false)
        .setIn(['activities', 'count'], actions.payload.data.count)
        .setIn(['activities', 'results'], Immutable.fromJS(results));
    },

    PERFORMANCE_ACTIVITY_FAILURE: (state: PerformanceStore, actions: PerformanceActionType) => {
      if (actions.payload && state.getIn(['activities', 'results', actions.payload])) {
        return state.setIn(['activities', 'results', actions.payload, 'isfetching'], false);
      } else {
        return state;
      }
    },

    PERFORMANCE_ACTIVITY_REQUEST: (state: PerformanceStore, actions: PerformanceActionType) => {
      if (actions.payload && state.getIn(['activities', 'results', actions.payload])) {
        return state.setIn(['activities', 'results', actions.payload, 'isfetching'], true);
      } else {
        return state;
      }
    },

    PERFORMANCE_ACTIVITY_RESPONSE: (state: PerformanceStore, actions: PerformanceActionType) => {
      const activity = actions.payload.activity;
      if (activity && state.getIn(['activities', 'results', activity])) {
        const type = actions.payload.data.type;
        if (type === 'LIST') {
          const schema = actions.payload.data.records.schema;
          const hasPanel = actions.payload.data.hasOwnProperty('records');
          const records = actions.payload.data.records.records.map((values: any[]) =>
            values.reduce((payment, value, index) => ({ ...payment, [schema.properties[index].name]: value }), {})
          );

          return state.setIn(['activities', 'results', actions.payload.activity, 'isfetching'], false).setIn(
            ['activities', 'results', actions.payload.activity, 'details'],
            Immutable.fromJS({
              type,
              records,
              hasPanel,
              total: actions.payload.data.total,
              currency: actions.payload.data.currency,
            })
          );
        } else {
          const yesterday = actions.payload.data.yesterday ? actions.payload.data.yesterday : null;
          const current = actions.payload.data.current ? actions.payload.data.current : null;
          const previous = actions.payload.data.previous ? actions.payload.data.previous : null;
          const ytd = actions.payload.data.ytd ? actions.payload.data.ytd : null;
          const total = actions.payload.data.total ? actions.payload.data.total : null;
          let chartData = null;
          const hasPanel = actions.payload.data.hasOwnProperty('records');
          const currency = actions.payload.data.currency ? actions.payload.data.currency : null;
          const chartType = getChartType(actions);
          const chartColor = activity === 'submissions' ? '#47b74a' : activity === 'simulations' ? '#f69526' : '#2991d1';
          const getRecordSeries = chartMapping['performance-profile'];

          if (
            actions.payload.data.records &&
            Array.isArray(actions.payload.data.records.records) &&
            actions.payload.data.records.records.length
          ) {
            const series = Immutable.fromJS(
              getRecordSeries({
                chartDataSchema: actions.payload.data.records.schema,
                chartDataRecords: actions.payload.data.records.records,
                color: chartColor,
                type: actions.payload.data.type,
                total,
                isReverse: true,
              })
            );

            chartData = {
              schema: actions.payload.data.records.schema,
              records: series,
            };
          }

          return state.setIn(['activities', 'results', actions.payload.activity, 'isfetching'], false).setIn(
            ['activities', 'results', actions.payload.activity, 'details'],
            Immutable.fromJS({
              yesterday,
              previous,
              current,
              ytd,
              total,
              chartData,
              chartType,
              currency,
              type: actions.payload.data.type,
              hasPanel,
            })
          );
        }
      } else {
        return state;
      }
    },

    PROFILE_PERFORMANCE_CLEAR: () => initialState,
  },
  initialState
);

export default PerformanceReducer;
